import {createTheme} from '@mui/material/styles';
import {useResponsive} from "./Modulo_Responsive/Hooks/useResponsive";


export const theme = createTheme({


    palette: {
        primary: {
            main: "#0082FB",
            light: '#000',
        },
        secondary: {
            main: "#1C2B33",
        },
        info: {
            main: "#FED001",
        },
        success: {
            main: "#00FF1E"
        },
        action: {
            main: "#FFF"
        },


    },
    typography: {
        fontFamily: '"Inter", sans-serif',
        h1: {
            fontWeight: 700,
            color: "#1C2B33",
            lineHeight: 1.2,
            fontSize: 40,
            "@media (min-width:600px)": {
                fontSize: 52,
            },
            "@media (min-width:900px)": {
                fontSize: 64,
            },
        },
        h2: {
            fontWeight: 700,
            color: "#1C2B33",
            lineHeight: 1.2,
            fontSize: 48,
            "@media (min-width:600px)": {
                fontSize: 50,
            },
            "@media (min-width:900px)": {
                fontSize: 52,
            },
        },
        h3: {
            fontWeight: 600,
            color: "#1C2B33",
            lineHeight: 1.2,
            fontSize: 22,
            "@media (min-width:600px)": {
                fontSize: 28,
            },
            "@media (min-width:900px)": {
                fontSize: 32,
            },
        },
        t3: {
            fontWeight: 700,
            color: "#1C2B33",
            lineHeight: 1.2,
            fontSize: 20,
            "@media (min-width:600px)": {
                fontSize: 20,
            },
            "@media (min-width:900px)": {
                fontSize: 20,
            },
        },
        h4: {
            fontSize: 24,
            fontWeight: 400,
        },
        h5: {
            fontSize: 16,
            fontWeight: 600,
        },
        body1: {
            fontSize: 16,
            fontWeight: 400,
            color: "#1C2B33",
            lineHeight: 1.2,
        },
        body2: {
            fontSize: 16,
            fontWeight: 600,
            color: "#1C2B33",
            lineHeight: 1.2,
        },
        allVariants: {
            color: "#000",
        },
    },
    components: {
        MuiGrid: {
            styleOverrides: {
                root: {
                    transition: "all .2s ease-in-out"
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                variant: "filled",
                size: "medium"
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 6,
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 6
                }
            }
        },
        MuiButtonBase: {
            variants: [
                {
                    props: {variant: 'efecto'},
                    style: {
                        transition: 'all .1s ease-in-out',
                        borderRadius: 10,
                        '&: hover': {
                            marginTop: -6,
                            boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",

                        }
                    },
                },


            ],

        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 10,
                    backgroundColor: '#131313',


                }
            }
        },
        MuiButton: {
            defaultProps: {
                variant: "contained",
            },
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    fontWeight: 600,
                    paddingLeft: 32,
                    paddingRight: 32,
                    fontSize: 16,
                    textTransform: 'none'


                },
            }
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {

                }
            }
        },



    }


})